import { isEmpty } from 'lodash'

// create masked sign based on pin length
const createMaskedPinSign = (pin) => {
  if (isEmpty(pin)) {
    return ''
  }

  const maskedSign = '●'
  const maskedPin = maskedSign.repeat(pin.length)

  return maskedPin
}

export const maskedPinUtils = {
  createMaskedPinSign,
}
